export const baseURL = 'https://api.amantrans.com.kz/';
// export const baseURL = 'http://192.168.0.5:8080/';
